import { render, staticRenderFns } from "./sourceNameItemData.vue?vue&type=template&id=03bf1375&scoped=true&"
import script from "./sourceNameItemData.vue?vue&type=script&lang=js&"
export * from "./sourceNameItemData.vue?vue&type=script&lang=js&"
import style0 from "./sourceNameItemData.vue?vue&type=style&index=0&id=03bf1375&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03bf1375",
  null
  
)

export default component.exports